"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsDialog = void 0;
const tslib_1 = require("tslib");
const catalog_forms_1 = require("@tableau/catalog-forms");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelManagement_1 = require("../LabelManagement");
const LabelCategories_1 = require("../shared/LabelCategories");
const LabelDialogStyle_1 = require("./LabelDialogStyle");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
const LabelsDialogSectionCategory_1 = require("./LabelsDialogSectionCategory");
const LabelsDialogSectionEditor_1 = require("./LabelsDialogSectionEditor");
const LabelsDialogSectionValue_1 = require("./LabelsDialogSectionValue");
const LabelSearchBar_1 = require("./LabelSearchBar");
const useLabelDialogInitialState_1 = require("./useLabelDialogInitialState");
function LabelsDialog({ contentItem, hideDialog, getAnchorClientRect, capabilities, initialCategory: initialCategoryProp }) {
    const state = (0, useLabelDialogInitialState_1.useLabelDialogInitialState)([contentItem], capabilities);
    const initialCategory = react_1.default.useMemo(() => {
        if (initialCategoryProp && (0, LabelCategories_1.isBuiltInLabelCategory)(initialCategoryProp)) {
            return initialCategoryProp;
        }
        return undefined;
    }, [initialCategoryProp]);
    const title = contentItem.contentName
        ? catalog_messages_1.Messages.LabelsDialog_Title({ ASSET_NAME: contentItem.contentName, ASSET_COUNT: 1, ASSET_COUNT_LOC: '' })
        : catalog_messages_1.Messages.LabelsDialog_Title_UnknownAsset();
    const dialogProps = {
        showCloseButton: true,
        isModal: true,
        type: widgets_1.DialogType.NormalWithTitleBar,
        positioningBehavior: widgets_1.DialogPositioningBehavior.Draggable,
        userResizeMode: widgets_1.DialogUserResizeMode.Horizontal,
        dialogWidth: 900,
        dialogHeight: 680,
        dialogBodyStyle: {
            padding: 0,
            borderBottom: LabelDialogStyle_1.border,
            overflow: 'hidden', // disable scroll for dialog body so panes can scroll individually
        },
        dialogStyle: {},
        onCloseRequest: hideDialog,
        handleGlassClick: undefined,
        getAnchorClientRect: getAnchorClientRect,
        title,
        testId: 'labels-dialog',
    };
    if (!state) {
        return (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, dialogProps),
            react_1.default.createElement(widgets_1.ActivitySpinnerWidget, { testId: 'labels-dialog-loading' })));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(LabelsDialogBody, { initialCategory: initialCategory, dialogProps: dialogProps, details: state.details, initialValues: state.initialValues, submit: state.submit })));
}
exports.LabelsDialog = LabelsDialog;
const heightOfBodyMinusSearchBar = 'calc(100% - 72px)';
function LabelsDialogBody(_a) {
    var { dialogProps, details, initialValues, submit } = _a, props = tslib_1.__rest(_a, ["dialogProps", "details", "initialValues", "submit"]);
    const initialSelection = react_1.default.useMemo(() => {
        var _a;
        const initialCategory = (_a = props.initialCategory) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        if (initialCategory) {
            return { kind: 'category', category: initialCategory };
        }
        return { kind: 'all' };
    }, [props.initialCategory]);
    const [state, dispatch] = (0, LabelsDialogContexts_1.useLabelDialogReducer)(initialSelection);
    return (react_1.default.createElement(LabelsDialogContexts_1.LabelDialogStateContext.Provider, { value: state },
        react_1.default.createElement(LabelsDialogContexts_1.LabelDialogDispatcherContext.Provider, { value: dispatch },
            react_1.default.createElement(LabelsDialogContexts_1.LabelDialogDetailsContext.Provider, { value: details },
                react_1.default.createElement(catalog_forms_1.FormikDialogWidget, Object.assign({}, dialogProps, { onReset: dialogProps.onCloseRequest, validateOnChange: false, initialValues: initialValues, onSubmit: (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        yield submit.mutateAsync({ state: values, original: initialValues });
                        dialogProps.onCloseRequest();
                    }), FooterContent: LabelsDialogFooterContent }),
                    react_1.default.createElement(LabelSearchBar_1.SearchBar, null),
                    react_1.default.createElement("div", { style: { display: 'flex', overflow: 'hidden', height: heightOfBodyMinusSearchBar } },
                        react_1.default.createElement(LabelsDialogSectionCategory_1.LabelDialogSectionCategory, { initialCategory: props.initialCategory }),
                        react_1.default.createElement(LabelsDialogSectionValue_1.LabelDialogSectionValue, null),
                        react_1.default.createElement(LabelsDialogSectionEditor_1.LabelDialogSectionEditor, null)))))));
}
function LabelsDialogFooterContent() {
    const { isSubmitting, isValid, dirty, handleSubmit, handleReset } = (0, LabelsDialogContexts_1.useLabelDialogState)();
    const { Dialog, abandon } = (0, catalog_forms_1.useConfirmOnCloseRequest)(handleReset);
    const disabled = isSubmitting || !isValid || !dirty;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dialog, null),
        react_1.default.createElement(FooterDiv, null,
            react_1.default.createElement("div", { style: { marginRight: 'auto' } },
                react_1.default.createElement(LabelManagement_1.LabelManagementLink, null)),
            react_1.default.createElement(widgets_1.ButtonWidget, { type: 'reset', onClick: abandon, disabled: isSubmitting }, catalog_messages_1.Messages.Cancel()),
            react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, type: 'submit', onClick: () => handleSubmit(), disabled: disabled, showSpinner: isSubmitting ? true : undefined }, catalog_messages_1.Messages.Save()))));
}
const FooterDiv = (0, vizportalclient_common_components_1.divWithStyle)('dialog-confirm-cancel-footer', {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-end',
    $nest: {
        '& > button ~ button': { marginLeft: widgets_1.TabStyles.Spacing.MediumSpace },
        '&:first-child': {
            marginRight: 'auto',
        },
    },
});
//# sourceMappingURL=LabelsDialog.js.map